import React from 'react';
import {Head} from 'react-static';
const {SITE_URL} = process.env;

export default function PageMeta({
  url = `${SITE_URL}masterclass/`,
  ogImage = 'https://cdn.foodrevolution.org/hhc/opengraph/hhc-open-graph-202107-masterclass-v3.jpg',
  title = 'Healthy Heart Masterclass – Watch FREE',
  description = 'Learn the four most dangerous heart health myths, plus TEN recent breakthroughs that can SLASH your risk of heart disease! Join renowned holistic cardiologist Dr. Mimi Guarneri and Food Revolution Network CEO Ocean Robbins for this completely FREE masterclass.'
}) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:site" content="@afoodrevolution" />
      <meta property="twitter:image" content={ogImage} />
      <meta property="fb:app_id" content="1685199371775570" />
      <meta property="og:site_name" content="Healthy Heart Masterclass" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Head>
  );
}
